import BaseApiService from './baseApi';

export function rememberAccountDetails(data) {
  let stored = {};
  try { stored = JSON.parse(localStorage.getItem('userAccountData') || '{}'); } catch { /* Replace an invalid cached profile. */ }
  localStorage.setItem('userAccountData', JSON.stringify({ ...stored, ...data }));
}

export function getMerchantCompanyId() {
  try { return JSON.parse(sessionStorage.getItem('skai1CompanyData'))?.companyId || null; }
  catch { return null; }
}

export function isMerchantOwner() {
  try {
    const roles = JSON.parse(localStorage.getItem('userData'))?.roles?.partner;
    return Array.isArray(roles) && roles.includes('Owner');
  } catch {
    return false;
  }
}

class MerchantAccountService extends BaseApiService {
  constructor() { super('/api/v1/partner/'); }
  path(path, companyId = getMerchantCompanyId()) {
    return companyId ? `${path}?companyId=${encodeURIComponent(companyId)}` : path;
  }
  async request(method, path, data, companyId) {
    const response = await this[method](this.path(path, companyId), data);
    if (response?.code !== 'OK') {
      const error = new Error(response?.message || '');
      error.code = response?.code;
      throw error;
    }
    return response.data;
  }
  getAccount(companyId) { return this.request('get', 'account-details', undefined, companyId); }
  updateAccount(data, companyId) { return this.request('put', 'account-details', data, companyId); }
  sendEmailOTP(email, changes = {}, companyId) { return this.request('post', 'account-details/email/otp', { ...changes, email }, companyId); }
  verifyEmailOTP(challengeId, otp, companyId) { return this.request('post', 'account-details/email/verify', { challengeId, otp }, companyId); }
  getSubscription(companyId) { return this.request('get', 'subscription', undefined, companyId); }
  getPaymentMethod(companyId) { return this.request('get', 'payment-method', undefined, companyId); }
  updatePaymentMethod(data, companyId) { return this.request('post', 'payment-method', data, companyId); }
  cancelSubscription(data) { return this.request('post', 'unsubscribe', data); }
  getHistory(page = 1, companyId) { return this.request('get', 'subscription/history', { page, size: 10 }, companyId); }
}

const merchantAccountService = new MerchantAccountService();
export default merchantAccountService;
